export enum FIRESTORE_PATH {
    ORDERS = 'orders',
    SHOPPING_CART = 'shopping-cart',
    USERS = 'users'
};